// Преводи за категории и тагове
export const categoryAndTagTranslations = {
  bg: {
    tasks: {
      create: {
        form: {
          category: "Категория",
          no_category: "Без категория",
          tags: "Тагове"
        }
      },
      details: {
        category: "Категория",
        tags: "Тагове"
      },
      errors: {
        fetch_failed: "Грешка при зареждане на задачите"
      },
      list: {
        card: {
          location: "Местоположение",
          deadline: "Краен срок"
        }
      }
    },
    common: {
      error_loading: "Грешка при зареждане на данните"
    }
  },
  en: {
    tasks: {
      create: {
        form: {
          category: "Category",
          no_category: "No category",
          tags: "Tags"
        }
      },
      details: {
        category: "Category",
        tags: "Tags"
      },
      errors: {
        fetch_failed: "Error loading tasks"
      },
      list: {
        card: {
          location: "Location",
          deadline: "Deadline"
        }
      }
    },
    common: {
      error_loading: "Error loading data"
    }
  },
  nl: {
    tasks: {
      create: {
        form: {
          category: "Categorie",
          no_category: "Geen categorie",
          tags: "Tags"
        }
      },
      details: {
        category: "Categorie",
        tags: "Tags"
      },
      errors: {
        fetch_failed: "Fout bij het laden van taken"
      },
      list: {
        card: {
          location: "Locatie",
          deadline: "Deadline"
        }
      }
    },
    common: {
      error_loading: "Fout bij het laden van gegevens"
    }
  },
  tr: {
    tasks: {
      create: {
        form: {
          category: "Kategori",
          no_category: "Kategori yok",
          tags: "Etiketler"
        }
      },
      details: {
        category: "Kategori",
        tags: "Etiketler"
      },
      errors: {
        fetch_failed: "Görevler yüklenirken hata oluştu"
      },
      list: {
        card: {
          location: "Konum",
          deadline: "Son tarih"
        }
      }
    },
    common: {
      error_loading: "Veriler yüklenirken hata oluştu"
    }
  },
  pl: {
    tasks: {
      create: {
        form: {
          category: "Kategoria",
          no_category: "Brak kategorii",
          tags: "Tagi"
        }
      },
      details: {
        category: "Kategoria",
        tags: "Tagi"
      },
      errors: {
        fetch_failed: "Błąd podczas ładowania zadań"
      },
      list: {
        card: {
          location: "Lokalizacja",
          deadline: "Termin"
        }
      }
    },
    common: {
      error_loading: "Błąd podczas ładowania danych"
    }
  }
};

// Функция за добавяне на преводите към съществуващите
export const addTranslations = (i18n: any) => {
  Object.keys(categoryAndTagTranslations).forEach(lang => {
    i18n.addResourceBundle(
      lang,
      'translation',
      categoryAndTagTranslations[lang as keyof typeof categoryAndTagTranslations],
      true,
      true
    );
  });
}; 